var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplierListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#C1D7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9142 18.1788C18.6953 18.9599 18.6953 20.2262 17.9142 21.0072C17.1332 21.7883 15.8668 21.7883 15.0858 21.0072C14.3047 20.2262 14.3047 18.9599 15.0858 18.1788C15.8668 17.3978 17.1332 17.3978 17.9142 18.1788",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19H27",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22.5H23",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.041C19.83 25.614 19.567 25.23 19.229 24.917V24.917C18.658 24.388 17.908 24.093 17.129 24.093H15.871C15.092 24.093 14.342 24.387 13.771 24.917V24.917C13.433 25.229 13.17 25.613 13 26.041",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 15H19C18.448 15 18 14.552 18 14V11C18 10.448 18.448 10 19 10H21C21.552 10 22 10.448 22 11V14C22 14.552 21.552 15 21 15Z",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13H12.041C10.914 13 10 13.914 10 15.041V27C10 28.105 10.895 29 12 29H28C29.105 29 30 28.105 30 27V15C30 13.895 29.105 13 28 13H22",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierListIcon);
export default __webpack_public_path__ + "static/media/SupplierListIcon.57ada27c40f197a9d5f8069169ccb943.svg";
export { ForwardRef as ReactComponent };